import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Views
import Home from '../views/Home.vue'
import CharacterDetail from '../views/CharacterDetail.vue'
import Chat from '../views/Chat.vue'
import Profile from '../views/Profile.vue'
import Messages from '../views/Messages.vue'
import Settings from '../views/Settings.vue'
import TestAuth from '../views/TestAuth.vue'
import SubscriptionExample from '../views/SubscriptionExample.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/character/:id',
    name: 'CharacterDetail',
    component: CharacterDetail,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat/:id',
    name: 'Chat',
    component: Chat,
    props: route => ({ id: Number(route.params.id) }),
    meta: { requiresAuth: true }
  },
  {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue')
  },
  {
    path: '/test-auth',
    name: 'TestAuth',
    component: TestAuth,
    meta: { requiresAuth: false }
  },
  {
    path: '/subscription',
    name: 'SubscriptionExample',
    component: SubscriptionExample,
    meta: { requiresAuth: true }
  },
  {
    path: '/subscription-confirmation',
    name: 'SubscriptionConfirmation',
    component: () => import('../views/SubscriptionConfirmation.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL || ''),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'Auth' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router 